<template>
    <div>
      <div class="details_content_repeat">
        <QS-scroller-box>
          <QS-h4-title title="退车信息" />
          <form-text-box
            :column="2"
            :dataList="dataList"
            :rules="configRules"
            :model="configDefaultValue"
            ref="returnInfo"
          >

          </form-text-box>
          <template slot="bottomAction">
            <el-button @click="goPageBack" size="mini">取消退车</el-button>
            <el-button
              :loading="submitLoading"
              type="primary"
              size="mini"
              @click="submitHandle"
              >发起退车</el-button
            >
          </template>
        </QS-scroller-box>
      </div>
    </div>
</template>

<script>
import { initiateVehicle } from '@/api/domain/orders'
import selectOptionDict from '@/store/dict/selectOptionDict'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  name: 'vehiclesettlements',
  data() {
    return {
      submitLoading: false,
      // eslint-disable-next-line vue/no-unused-properties
      selectOptionDict,
      // configCloumn: [
      //   {
      //     type: 'text',
      //     label: '应收押金',
      //     key: 'receivableDeposit'
      //   },
      //   {
      //     type: 'select',
      //     label: '退车类型',
      //     key: 'closeType',
      //     source: {},
      //     options: {
      //       clearable: true,
      //       filterable: true
      //     }
      //   },
      //   {
      //     type: 'textarea',
      //     label: '退车原因',
      //     key: 'closeReason',
      //     options: {
      //       maxlength: 50,
      //       clearable: true
      //     }
      //   }
      // ],
      configDefaultValue: {
        receivableDeposit: '', // 应收押金
        closeType: '', // 退车类型
        closeReason: '', // 退车原因
      },
      configRules: {
        closeType: [
          { required: true, message: '请选择退车类型', trigger: 'change' },
        ],
        closeReason: [
          { required: true, message: '退车原因不能为空', trigger: 'change' },
        ],
      },
      // 表单配置项
      dataList: [
        {
          el: 'text',
          itemConfig: {
            label: '应收押金',
            prop: 'receivableDeposit',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '退车类型',
            prop: 'closeType',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '退车原因',
            prop: 'closeReason',
            type: 'textarea',
          },
          elConfig: {
            type: 'textarea',
            maxlength: 50,
            showWordLimit: true,

          },
        },
      ],
    }
  },
  inject: ['orderData'],
  watch: {
    orderData: {
      deep: true,
      immediate: true,
      handler(val) {
        const orderId = val.orderId || this.$route.query.id
        if (val && orderId) {
          this.configDefaultValue.receivableDeposit = `${
            this.numberWithCommas(val.totalDeposit) || '0.00'
          } / ${this.numberWithCommas(val.receivedDeposit) || '0.00'}`
          // this.$refs.configData && this.$refs.configData.initParams()
        }
      },
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    setData(data) {
      this.configDefaultValue.receivableDeposit =
          data.settlementInfo.receivableDeposit
      // this.$nextTick(() => {
      //   this.$refs.configData.initParams()
      // })
    },
    async searchHandle(params) {
      const { id } = this.$route.query
      this.submitLoading = true
      try {
        const { code, data } = await initiateVehicle({
          orderId: id,
          closeType: Number(params.closeType),
          closeReason: params.closeReason,
        })
        if (code === 1 && data) {
          this.$message({
            message: '退车成功',
            type: 'success',
          })
          const { state } = this.$route.query
          this.sendMessage(id)
          if (Number(state) === 0 || Number(state) === 1500) {
            const query = { id, state: 4500, type: 5, returnInfoType: 1 }
            const { orderType = '' } = this.$route.query
            if (orderType === 'enterChild') {
              this.$refreshBack()
              this.$router.push({
                path: '/workbench/entOrder/detail/child',
                query: {
                  ...query,
                },
              })
            } else {
              this.$refreshBack()
              this.$router.push({
                path: '/workbench/rentOrder/detail',
                query,
              })
            }
            this.$nextTick(() => {
              window.location.reload()
            })
          } else {
            this.goPageBack()
          }
        }
        this.submitLoading = false
      } catch (error) {
        this.submitLoading = false
      }
    },
    submitHandle() {
      // this.$refs.configData.onSubmit()
      this.$refs.returnInfo.getRefs().validate((validate) => {
        if (validate) {
          this.searchHandle(this.configDefaultValue)
        }
      })
    },
    // 返回上一级
    goPageBack() {
      const { orderType = '' } = this.$route.query
      this.$refreshBack()
      if (orderType === 'enterChild') { // 如果是通过企业子订单跳转过来的详情，再跳回去企业租赁子订单列表
        this.$router.push('/workbench/entOrder/list?listType=child')
      } else {
        this.$router.push('/workbench/rentOrder/list')
      }
    },
    // 字典数据返回数组下拉框
    filterDictArray(dict) {
      const result = []
      for (const key in dict) {
        result.push({ name: dict[key], id: key })
      }
      return result
    },
    sendMessage(id) {
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: id,
        })
      }
    },
  },
  mounted() {
    const { state } = this.$route.query
    // 0:待确认,1000:订单待支付 1500:发车待验车 2500:履约中

    if ([0, 1000, 1500].includes(Number(state))) {
      // 待确认、待出库
      // this.configCloumn.forEach((item) => {
      //   if (item.key === 'closeType') {
      //     item.source = selectOptionDict.returnTypeToBeConfirmed
      //     const result = this.filterDictArray(selectOptionDict.returnTypeToBeConfirmed)
      //     this.$refs.returnInfo.setItemData({ elConfigKey: 'list', key: 'closeType', data: result })
      //   }
      // })
      // 待确认、待出库
      this.dataList.forEach((item) => {
        if (item.itemConfig.prop === 'closeType') {
          const result = this.filterDictArray(selectOptionDict.returnTypeToBeConfirmed)
          this.$refs.returnInfo.setItemData({ elConfigKey: 'list', key: 'closeType', data: result })
        }
      })
    } else if (Number(state) === 2500) {
      // 履约中
      // this.configCloumn.forEach((item) => {
      //   if (item.key === 'closeType') {
      //     item.source = selectOptionDict.closingReasonInPerformance
      //   }
      // })
      this.dataList.forEach((item) => {
        if (item.itemConfig.prop === 'closeType') {
          const result = this.filterDictArray(selectOptionDict.closingReasonInPerformance)
          this.$refs.returnInfo.setItemData({ elConfigKey: 'list', key: 'closeType', data: result })
        }
      })
    }
  },
}
</script>

